import Cookies from 'js-cookie';

const setToken = (token: string) => Cookies.set('token', token);
const getToken = () => Cookies.get('token');
const removeToken = () => Cookies.remove('token');
const AuthUtils = {
  setToken,
  getToken,
  removeToken,
};

export default AuthUtils;